var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 311.6 28.8",
    style: {
      enableBackground: "new 0 0 311.6 28.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8,28.3h-5.3l-4.4-11.5H5v11.5H0v-28h12.1c3.4,0,5.9,0.8,7.4,2.3s2.4,3.5,2.4,5.9c0,3.6-1.7,6.1-5,7.4L21.8,28.3z  M5,12.8h6.3c1.8,0,3.2-0.4,4.1-1.1c0.9-0.7,1.3-1.8,1.3-3.2c0-1.2-0.4-2.2-1.3-3c-0.9-0.8-2.1-1.1-3.7-1.1H5V12.8z M32,28.3h-5v-28 h5V28.3z M59.4,14v14.3h-2.2l-1.5-3.8c-1.7,2.9-4.2,4.3-7.6,4.3c-3.8,0-6.7-1.4-8.5-4.3s-2.8-6.3-2.8-10.1c0-4,1-7.4,3.1-10.2 s5-4.2,8.8-4.2c2.8,0,5.1,0.8,7,2.5s3,3.7,3.4,6.1l-4.4,0.8c-0.8-3.4-2.8-5.1-5.9-5.1c-2,0-3.6,0.8-4.9,2.4s-1.8,3.9-1.8,7.3 c0,7.1,2.2,10.6,6.6,10.6c1.7,0,3.1-0.6,4.3-1.8s1.7-2.8,1.7-4.7h-5.8V14C48.9,14,59.4,14,59.4,14z M85.9,28.3h-5V16.2H70.2v12.2h-5 v-28h5v11.4h10.7V0.3h5C85.9,0.3,85.9,28.3,85.9,28.3z M101.8,28.3h-5.4V4.7H89V0.3h20.3v4.3h-7.4L101.8,28.3L101.8,28.3z  M140.1,28.3h-17.2v-28h5.3v23.5h11.9V28.3z M162,28.3h-18.2v-28h18v4.2h-13v7.6h10.4v4.1h-10.4V24h13.1L162,28.3L162,28.3z  M188.3,28.3h-5.4l-2.2-6.7h-10.8l-2.2,6.7h-4.3l9.3-28h6.2L188.3,28.3z M179.3,17.6l-4.1-12.5l-4.1,12.5H179.3z M212.8,28.3h-4.9 l-10.6-17.9c-0.2-0.3-0.4-0.7-0.8-1.3c-0.2-0.3-0.4-0.7-0.8-1.3v20.5h-4.1v-28h5.6l9.9,16.5c0.1,0.1,0.7,1.1,1.8,3V0.3h4v28H212.8z  M246.7,28.3h-17.2v-28h5.3v23.5h11.9V28.3z M268.6,28.3h-18.2v-28h18v4.2h-13v7.6h10.4v4.1h-10.4V24h13.1v4.3H268.6z M278.1,28.3 h-5.2v-28h17.7v4.3h-12.5v7.6h9.8v4.2h-9.8V28.3z M304.1,28.3h-5.4V4.7h-7.4V0.3h20.3v4.3h-7.5V28.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRll);
export default __webpack_public_path__ + "static/media/RLL.cb1b1df91facfdbe202c17d40b600132.svg";
export { ForwardRef as ReactComponent };